module.exports = __webpack_public_path__ + "static/media/cancel.2604257b.svg";